import type { SVGProps } from 'react';

export const Instagram = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.006 9.83c1.196 0 2.17.974 2.17 2.17s-.974 2.17-2.17 2.17A2.174 2.174 0 0 1 9.836 12c0-1.196.974-2.17 2.17-2.17Z" />
      <path d="M15.04 6.791c1.197 0 2.169.973 2.169 2.17v6.077a2.171 2.171 0 0 1-2.17 2.171H8.962a2.172 2.172 0 0 1-2.171-2.17V8.961c0-1.198.973-2.171 2.17-2.171h6.078Zm-3.034 1.953a3.257 3.257 0 0 0 0 6.512A3.257 3.257 0 0 0 15.262 12a3.257 3.257 0 0 0-3.256-3.256Zm3.473-.868a.652.652 0 1 0 .002 1.304.652.652 0 0 0-.002-1.304Z" />
      <path d="M20 0a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4h16ZM8.744 5.705a3.04 3.04 0 0 0-3.039 3.04v6.51a3.04 3.04 0 0 0 3.04 3.04h6.51a3.04 3.04 0 0 0 3.04-3.04v-6.51a3.04 3.04 0 0 0-3.04-3.04h-6.51Z" />
    </svg>
  );
};
